import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
}

const FireIcon: React.FC<Props> = ({ fill = "#CAA278", stroke = "#CAA278", ...props }) => {
  return (
    <svg
      {...props}
      width="33"
      height="38"
      viewBox="0 0 33 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.35 36.75C24.9657 36.75 31.95 29.9642 31.95 21.5934C31.95 15.9834 28.8128 8.53232 24.15 4.22773L20.25 9.27558L13.425 0.75C6.6 5.48643 0.75 14.1941 0.75 21.5934C0.75 29.9642 7.73435 36.75 16.35 36.75Z"
        fill={fill}
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FireIcon;
